import {
  STORE_CIRCUS_AGREEMENT,
  STORE_PERSONAL_RELATION_AGREEMENT,
  STORE_THIRD_PARTY_AGREEMENT,
  STORE_PERSONAL_RELATION_CARD_IS_DISPLAY,
  STORE_THIRD_PARTY_CARD_IS_DISPLAY,
  STORE_ADVERTISING_AGREEMENT,
  STORE_ADVERTISING_CARD_IS_DISPLAY,
} from "actions"

export const initialState = {
  personalRelationAgree: "0",
  personalRelationCardIsDisplay: undefined,
  advertisingAgree: 0,
  advertisingCardIsDisplay: undefined,
  thirdpartyAgreeBasicDcm: "0",
  thirdpartyAgreeBasicDpt: "0",
  thirdpartyAgreeBasicCorp: "0",
  thirdpartyAgreeUserDcm: "0",
  thirdpartyAgreeUserDpt: "0",
  thirdpartyAgreeUserCorp: "0",
  thirdpartyAgreeLocationDcm: "0",
  thirdpartyAgreeLocationDpt: "0",
  thirdpartyAgreeLocationCorp: "0",
  thirdpartyAgreeHealthDcm: "0",
  thirdpartyAgreeHealthDpt: "0",
  thirdpartyAgreeHealthCorp: "0",
  thirdpartyAgreeOtherDcm: "0",
  thirdpartyAgreeOtherDpt: "0",
  thirdpartyAgreeOtherCorp: "0",
  thirdPartyCardIsDisplay: undefined,
  campaign: { isCampaign: false, entry: false }, // ポイント付与キャンペーン
}

export const AgreementSelection = (state = initialState, action) => {
  switch (action.type) {
    case STORE_CIRCUS_AGREEMENT:
      return { ...state, ...action.payload }
    case STORE_PERSONAL_RELATION_AGREEMENT:
      return { ...state, ...action.payload }
    case STORE_PERSONAL_RELATION_CARD_IS_DISPLAY:
      return { ...state, personalRelationCardIsDisplay: action.payload }
    case STORE_THIRD_PARTY_AGREEMENT:
      return { ...state, ...action.payload }
    case STORE_THIRD_PARTY_CARD_IS_DISPLAY:
      return { ...state, thirdPartyCardIsDisplay: action.payload }
    case STORE_ADVERTISING_AGREEMENT:
      return { ...state, ...action.payload }
    case STORE_ADVERTISING_CARD_IS_DISPLAY:
      return { ...state, advertisingCardIsDisplay: action.payload }

    default:
      return state
  }
}

export default AgreementSelection
